// dependencies
import { useContext, useEffect } from 'react';
import { ThemeContext } from '../ThemeContext';

// assets
import Sparkle from "../assets/icons/sparkle.svg";
import SparkleDark from "../assets/icons/sparkle-dark.svg";

// components
import Web from "./home/Web";
import CTA from "./shared/CTA";
import Product from './home/Product';

function Home() {
    const { darkTheme } = useContext(ThemeContext);

    useEffect(() => {
        const sparkleImages = document.querySelectorAll('img[alt="Sparkle"]');
        if (darkTheme) {
            sparkleImages.forEach(img => img.src = SparkleDark);
        } else {
            sparkleImages.forEach(img => img.src = Sparkle);
        }
    }, [darkTheme]);

    return (
        <main>
            <section className="work-hero">
                <header className="mb-2">
                    <div className="name-title mb-3">
                        <h1>Jihan Duerme</h1>
                        <img src={Sparkle} alt="Sparkle" />
                        <h1>UI/UX Designer</h1>
                    </div>
                    <h1 className="main-title">Designing data-driven, user-centric digital experiences that drive results</h1>
                </header>
                <p>I’ve worked with startups to enterprise teams to research, analyze, explore, strategize and build compelling products that scale with their mission</p>
                <a href="https://jihanduerme.com/about" className="button">About Me</a>
            </section>
            <section className="work-sections">
                <Product />
                <Web />
            </section>
            <CTA />
        </main>
    );
};

export default Home;